// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"17ab77b0d01a28af4f86","655":"ecd2038e00e0d39c46f7"}[chunkId] + ".js";
};